export default __webpack_public_path__ + "static/media/black-freehand-line-measure-icon.198938f5.svg";